(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('BillingSchedule', BillingSchedule);

    BillingSchedule.$inject = ['$resource'];

    function BillingSchedule ($resource) {
        var resourceUrl =  'api/billing-schedules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
